module.exports = __webpack_public_path__ + "static/media/welcome-1.0aa23b13.mp3";